// extracted by mini-css-extract-plugin
export default {"wrapper":"SupportPage_wrapper__ISX+1","addressBlock":"SupportPage_addressBlock__6j4Oi","button":"SupportPage_button__PQVrU"};